import { Designer, DesignerAPI } from '@brg/api';

import { useAPIMethod } from '../useAPIMethod';

export const useDesignerById = (designerId: string, lang?: string, t?: unknown) =>
  useAPIMethod<Designer, any>(DesignerAPI.Get, { idDesigner: designerId }, lang, t);
import { Designer, DesignerAPI } from '@brg/api';

import { useAPIMethod } from '../useAPIMethod';

export const useDesignerById = (designerId: string, lang?: string, t?: unknown) =>
  useAPIMethod<Designer, any>(DesignerAPI.Get, { idDesigner: designerId }, lang, t);
